import { connect } from 'react-redux'
import { isSubmitting, getFormValues } from 'redux-form'
import { isSuper, hasPermission } from 'Common'

import { FORM_NAME } from '../../Form'

import onClickCancel from './Handlers/onClickCancel'
import onClickSubmit from './Handlers/onClickSubmit'
import onClickSendForApproval from './Handlers/onClickSendForApproval'
import onClickApprove from './Handlers/onClickApprove'
import onClickExpire from './Handlers/onClickExpire'

import Component from './Component'

const mapStateToProps = (state) => {
  const formValues = getFormValues(FORM_NAME)(state) || {}
  return {
    submitting: isSubmitting(FORM_NAME)(state),
    ramsRecordStatus: formValues.status || null,
    isHsUser: isSuper() || hasPermission('allow_hs'),
  }
}

const actionCreators = {
  onClickCancel,
  onClickSubmit,
  onClickSendForApproval,
  onClickApprove,
  onClickExpire,
}

export default connect(mapStateToProps, actionCreators)(Component)